import { jsx as _jsx } from "react/jsx-runtime";
import { Arrow } from '@commercial-website/icons';
import { ButtonLink } from '../../atoms/button/button-link';
// No webm encode of this demo clip is available, so `video.webm` is omitted here —
// BillboardHero renders whichever `<source>`s are present, webm first when both are.
export const billboardHeroVideoMedia = {
    video: {
        mp4: 'https://videos.pexels.com/video-files/7657449/7657449-hd_1920_1080_25fps.mp4',
    },
    poster: 'https://placehold.co/1600x900',
};
export const billboardHeroMock = {
    media: {
        image: _jsx("img", { src: "https://placehold.co/1600x900", alt: "", loading: "eager" }),
    },
    title: 'Pleo it. Done.',
    subtitle: 'Issue cards, pay bills, and automatically sync your books in the background',
    children: (_jsx(ButtonLink, { variant: "pink", icon: _jsx(Arrow, {}), label: "Start your trial", href: "/start-trial" })),
    tag: (_jsx("img", { src: "https://commercial-helios.cdn.prismic.io/commercial-helios/aYxWA90YXLCxVrVH_g2-rating.svg", alt: "Rated 4.8/5 on G2" })),
    logoRow: {
        caption: 'Trusted by 40,000+ companies across Europe',
        logos: [
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/d9d3b3b6-c45c-4823-9205-f463ab248f32_soho%20house%20logo-02.svg", alt: "Soho House" }, "soho-house"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/ef470c53-8f56-4448-b1e1-4080cf075bfc_Blinkist.svg", alt: "Blinkist" }, "blinkist"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/729c0a9d-23d6-426a-9973-d67c024ec6e1_hello%20fresh%20logo.svg", alt: "HelloFresh" }, "hellofresh"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/71f2f2a3-9db8-4131-98ed-1c05f5dbf52a_lyst%20logo.svg", alt: "Lyst" }, "lyst"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/0a6becfd-44ed-4e7b-970f-be70e7a2dd51_Unity_black.svg", alt: "Unity" }, "unity"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/dd165de9-a212-4240-a7bc-e64706b6e4ed_Clean%20up%20Ocean.svg", alt: "Clean up Ocean" }, "clean-up-ocean"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/43f2efb8-854d-4c34-a205-dfdd50df13c9_Trade%20Republic.svg", alt: "Trade Republic" }, "trade-republic"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/a76dc2c7-05dd-4161-a7f9-2e3683a721d6_too-good-to-go%20(1).svg", alt: "Too Good To Go" }, "too-good-to-go"),
            _jsx("img", { src: "https://prismic-io.s3.amazonaws.com/commercial-helios/d9d3b3b6-c45c-4823-9205-f463ab248f32_soho%20house%20logo-02.svg", alt: "Soho House" }, "soho-house-2"),
        ],
    },
};
